<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="modal-header">
  <h4 class="modal-title pull-left">New Report</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-sm-12">
      <p class="report-create-info">
        Please enter legal name of business entity as it appears on the tax returns.
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="form-group" [ngClass]="{'has-warning': !validLength()}">
        <label class="rbv-label">Corporate Name</label>
        <input type="text" [(ngModel)]="companyName" placeholder="Corporate Name" class="form-control rounded-0" [ngClass]="{'is-invalid': !validLength()}"
               name="companyName" maxlength="251" autocomplete="off" (keydown.enter)="onConfirm()" autofocus="autofocus"/>

        <span *ngIf="!validLength()" class="invalid-feedback">
            Maximum of 250 characters only
          </span>
      </div>

      <div class="form-group">
        <Label class="rbv-label">Type of Report</Label>
        <input-search placeholder="Select Type of Report" [regular]="true"
                      [preset]="repTypeValues" [inputValue]="reportType" (valueChange)="reportTypeChanged($event)">
        </input-search>
      </div>

      <div class="form-group">
        <label class="rbv-label">Stage</label>
        <input-search placeholder="Select Stage" [regular]="true" [preset]="stagesValues" [inputValue]="stageId"
                      (valueChange)="stageValueChanged($event)"></input-search>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv" [disabled]="!validateInput()" (click)="onConfirm()">Create</button>
</div>
